import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';

const Irrigated = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="irrigated"
      name="irrigated"
      items={[
        { key: null, value: 'Select irrigation status' },
        { key: true, value: 'Yes' },
        { key: false, value: 'No' }
      ]}
      label="Irrigated"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select irrigation status"
    />
  );
};

export default Irrigated;
